module.exports = __webpack_public_path__ + "static/media/instagram.6f7f616f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/instagram.svg
// module id = 512
// module chunks = 0